import React, { useEffect, useRef, useState, useMemo } from 'react'
import { CONFIG } from '../../../config';
import { getPermissionKey } from '../../../helper/permissions';
import GenericTableComponent from '../../../genericComponents/tableComponent/GenericTableComponent';
import GenericInput from '../../../genericComponents/input/GenericInputComponent';
import Icons from '../../../assets/icons';
import { Search, ChevronLeft, ChevronRight, ChevronDown, Menu, ChartLine, Table2, ListCheck, Clock, Grid3x3, Box, Scissors, Layers, Package, Truck, ArrowUp, ArrowDown } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler, handleApiChange } from '../../../helper/apiHelperFunctions';
import dayjs from 'dayjs';
import ParentModal from '../../../genericComponents/ParentModal';
import GenericSpinnerLoader from '../../../loaders/GenericSpinnerLoader';
import DesignStagesModal from './DesignStagesModal';
import TNADashGraphView from './TNADashGraphView';
import TableLoader from '../../../genericComponents/oldGenericComponents/tableHelperComponents/TableLoader';
import NoDataFound from '../../../genericComponents/NoDataFound';
import { useVirtualizer } from '@tanstack/react-virtual';
import TextWithTooltip from '../../../genericComponents/TextWithTooltip';
import SplitPane from './SplitPlane';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import { modifyDataForDocumentViewerUrlInsertion } from '../../../helper/helperTableFunctions';
import { getPayloadFromURLParams, setPayloadAsURLParams } from '../../../helper/URLParamsHelper';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';

function TNAAnalysis(props) {

    let tableHeadersMap = {
        main: {
            name: "Main",
            key: "TNA_DASHBOARD_DATA"
        }
    }

    const jumpInputRef = useRef();

    const location = useLocation();
    const history = useHistory();

    const getTableComponentFifthListData = useSelector(state => state.generalStore.getTableComponentFifthListData);
    const generalStore = useSelector(state => state.generalStore);
    const getTableComponentListData = useSelector(state => state.generalStore.getTableComponentListData);
    const getTableComponentFourthListData = useSelector(state => state.generalStore.getTableComponentFourthListData);

    const dispatch = useDispatch();

    let observerTarget = useRef();
    const tableContainerRef = useRef(null);

    const [updatetablePayload, setUpdatetablePayload] = useState(false);
    const [headersData, setHeadersData] = useState({});
    const [headersType, setHeadersType] = useState("Default Headers");
    const [assortmentsList, setAssortmentsList] = useState([]);

    const [selectedData, setSelectedData] = useState(false);
    const [selectedModal, setSelectedModal] = useState(false);

    const [inputData, setInputData] = useState({
        viewMode: {
            icon: <ChartLine size={19} strokeWidth={1.75} />,
            key: "graphicalView",
            viewMode: "Graphical View",
        }
    });
    const [selectedAssortment, setSelectedAssortment] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [refreshTable, setRefreshTable] = useState(false);
    const [tnaDashSummary, setTnaDashSummary] = useState({});
    const [tableData, setTableData] = useState([])
    const [statusName, setStatusName] = useState({})
    const [filters, setFilters] = useState({
        onTrack: false,
        delayed: false
    });
    const [search, setSearch] = useState("")
    const [showSelected, setShowSelected] = useState(false);

    const [enableJumpPage, setEnableJumpPage] = useState(false);
    const [tnaTableData, setTnaTableData] = useState({
        currentPage: 1,
        maxPage: 1,
        pageSize: 10,
        pageNumber: 1,
    })
    const [sortConfig, setSortConfig] = useState({ sortedBy: "", sortedIn: "" });

    const moveNextPage = () => {
        if (Number(currentPage || "") < Number(maxPage || "") && assortmentsList?.length > 0) {
            let pageNo = currentPage;
            pageNo += 1;
            setCurrentPage(pageNo);
        }
    }

    // Function : To get the ref for the last element of the list.
    const lastListElementRef = (node) => {
        if (getTableComponentFifthListData?.isLoading) return;

        if (assortmentsList && assortmentsList?.length == 0) return;
        if (observerTarget?.current) observerTarget?.current?.disconnect();
        observerTarget.current = new IntersectionObserver(entries => {
            if (entries?.[0].isIntersecting) {
                // So that the state current page and max page state gets updated
                moveNextPage();
            }
        })
        if (node) observerTarget.current.observe(node);
    }

    console.log("this is the tnaDashSummary", tnaDashSummary)

    const getAssortmentListData = () => {
        let payload = {
            entity: "item",
            key: "tna_assortment_name",
            code: "",
            search: "",
            searchBy: "CONTAINS",
            pageNo: currentPage ?? 1,
            moduleName: "",
            other_data: {},
            columnName: {},
            apiUrl: "/plan/settings/search/arsGenericFilters",
            search: search?.toString()?.trim() ?? undefined
        };
        dispatchHandler(dispatch, "getTableComponentFifthListRequest", payload, getPermissionKey("common", "commonFunctionality", "view"))
    }

    useEffect(() => {
        getTnaSummaryData();
        handleApiChange(dispatch, "getHeadersRequest", {
            enterpriseName: "TURNINGCLOUD",
            displayName: "TNA_DASHBOARD_DATA",
            basedOn: "main",
        })
    }, [])

    useEffect(() => {
        getAssortmentListData();
    }, [currentPage])

    useEffect(() => {
        if(!search) {
            setAssortmentsList([])
            setCurrentPage(1);
            getAssortmentListData();
        }
    }, [search])

    useEffect(() => {
        if(Object.keys(selectedAssortment || {})?.length == 0) {
            setShowSelected(false)
        }
    }, [selectedAssortment])

    console.log("this is the headers data ", headersData, headersType)

    useEffect(() => {
        if (getTableComponentFifthListData?.isSuccess) {
            if (search && currentPage === 1) {
                setAssortmentsList([...getTableComponentFifthListData?.data?.resource?.searchResult || []]);
            } else {
                setAssortmentsList([...assortmentsList, ...getTableComponentFifthListData?.data?.resource?.searchResult || []]);
            }
            // setAssortmentsList([...assortmentsList, ...getTableComponentFifthListData?.data?.resource?.searchResult || []]);
            setMaxPage(getTableComponentFifthListData?.data?.resource?.maxPage ?? 1)
        }
        if (generalStore?.getHeadersData?.isSuccess && generalStore?.getHeadersData?.data?.basedOn == "main") {
            let data = generalStore?.getHeadersData?.data?.resource || {};
            let type = Object.keys(data?.["Custom Headers"] || {})?.length > 0 ? "Custom Headers" : "Default Headers"
            setHeadersData(data)
            setHeadersType(type)
        }

        if (getTableComponentFourthListData?.isSuccess) {
            setTnaDashSummary(getTableComponentFourthListData?.data ?? {});
            const mappedData = getTableComponentFourthListData?.data?.tnaDashboardData?.map?.((item) => ({
                ...item,
                statusName: item?.status_name
            })) || [];

            const allItem = {
                on_track_count: mappedData.reduce((sum, item) => sum + (item.on_track_count || 0), 0),
                delayed_count: mappedData.reduce((sum, item) => sum + (item.delayed_count || 0), 0),
                total_count: mappedData.reduce((sum, item) => sum + (item.total_count || 0), 0),
                status_name: "All",
                statusName: "All",
                status_order: -1
            };
            setStatusName(allItem);
            setRefreshTable(true);
        }

        if (getTableComponentListData?.isSuccess) {
            setTableData(getTableComponentListData?.data?.resource || []);
            setTnaTableData((prevState) => ({
                ...prevState,
                currentPage: getTableComponentListData?.data?.currPage,
                maxPage: getTableComponentListData?.data?.maxPage,
                pageSize: getTableComponentListData?.data?.pageSize,
                totalRecord: getTableComponentListData?.data?.totalRecord
            }));
        }
        else if(getTableComponentListData?.isError) {
            setTableData([]);
            setTnaTableData((prevState) => ({
                ...prevState,
                currentPage: 1,
                maxPage: 1,
                pageSize: 10,
                totalRecord: 0
            }));
        }
    }, [getTableComponentFifthListData?.isSuccess, generalStore?.getHeadersData?.isSuccess, getTableComponentFourthListData?.isSuccess, getTableComponentListData?.isSuccess, getTableComponentListData?.isError])

    const changePage = (page) => {
        setTnaTableData((prevState) => ({
            ...prevState,
            current: page,
        }));
        getTableData({
            pageNo: page,
        });
    }

    useEffect(() => {
        if (enableJumpPage) {
            setTimeout(() => document.addEventListener("click", closeJumpPage), 0)
        }

        return () => {
            setTimeout(() => document.removeEventListener("click", closeJumpPage), 0)
        };
    }, [enableJumpPage]);

    const setPageNumberValue = (e) => {
        let pageNumber = Number(e.target.value),
            valid = e.target.value == "" || (/^\d*$/.test(pageNumber) && pageNumber > 0 && pageNumber <= tnaTableData?.maxPage);
        if (valid) {
            setTnaTableData((prevState) => ({
                ...prevState,
                pageNumber: pageNumber,
            }));
            if (e.key == "Enter" && pageNumber && pageNumber != tnaTableData?.currentPage) {
                changePage(pageNumber);
                setEnableJumpPage(false);
            }
        }
    }

    const closeJumpPage = (e) => {
        if (jumpInputRef?.current && !jumpInputRef.current.contains(e.target)) {
            setEnableJumpPage(false);
        }
    }

    const handleJumpPage = () => {
        setEnableJumpPage(true);
    }

    const renderAssortmentList = () => {

        const checkedAssortments = assortmentsList.filter(item => selectedAssortment[item]);
        const unCheckedAssortments = assortmentsList.filter(item => !selectedAssortment[item]);

        return (
            <div className="w-[260px] h-full bg-white border border-[#DAE4EE] flex flex-col rounded-[3px] overflow-hidden">
                <div className="">
                    <div className="flex items-center gap-2 bg-[#F8F8F8] px-[10px] py-[10px]">
                        <ListCheck className="w-[20px] h-[20px] text-[#67768E]" />
                        <h2 className="font-semibold text-gray-900 text-[14px] m-0">Assortment Names</h2>
                    </div>
                    {/* <div className="relative border-t-[#DAE4EE] border-t border-b border-b-[#DAE4EE]">
                        <input
                            type="text"
                            placeholder="All"
                            className="w-full h-[40px] pl-3 pr-8 py-2 border-0 border-none rounded-[4px] font-medium text-sm focus:outline-none"
                        />
                        
                    </div> */}
                    <GenericInput
                        type="text"
                        placeholder="Search"
                        value={search || ''}
                        onChange={(e) => {setSearch(e?.target?.value)}}
                        onKeyDown={(e) => {e.key == 'Enter' && handleChange('search')}}
                        dependentFieldsObject={[search]}
                        isClearable={true}
                        onClear={() => setSearch('')}
                        iconRight={<Search size={15} color='#67768E' />}
                        genInputExtraClass='!m-0'
                        gibInnerClassName='!px-2.5 !border-0 !border-y !rounded-none'
                    />
                </div>

                {checkedAssortments?.length > 0 && <div className="text-xs">
                    {(!showSelected && checkedAssortments?.length > 0) && <div>
                        {checkedAssortments?.slice(0, 5)?.map((item, index) => (
                        <div key={index} className={`border-b last:border-b-0 border-[#F8F8F8] ${selectedAssortment[item] ? 'bg-[#5D5FEF0F]' : ""} py-[10px] px-[10px] hover:bg-[#5D5FEF0F]`}>
                            <label className={`generic-checkbox !block !font-normal`}>
                                <input
                                    type="checkbox"
                                    checked={!!selectedAssortment[item]}
                                    onChange={() => handleChange("checkAssortment", item)}
                                />
                                <span className="checkmark1"></span>
                                <TextWithTooltip
                                    as='p'
                                    className='mb-0 text-[11px] font-normal'
                                    text={item}
                                    width={'100%'}
                                />
                            </label>
                        </div>
                    ))}
                    </div>
                    }
                    {(showSelected ? checkedAssortments?.length > 0 : checkedAssortments?.length > 5) && <div className='px-3 py-2 text-xs font-medium text-fontBlack cursor-pointer hover:opacity-75 border-y border-borderSlateGrey' onClick={()=>setShowSelected(!showSelected)}>{showSelected ? 'View Less' : `+${checkedAssortments?.length-5} View More`}</div>}
                </div>}

                <div className="flex-1 overflow-y-auto">
                    {((showSelected && checkedAssortments?.length > 0) ? checkedAssortments : unCheckedAssortments)?.length ? ((showSelected && checkedAssortments?.length > 0) ? checkedAssortments : unCheckedAssortments)?.map((item, index) => (
                        <div key={index} className={`border-b last:border-b-0 border-[#F8F8F8] ${selectedAssortment[item] ? 'bg-[#5D5FEF0F]' : ""} py-[10px] px-[10px] hover:bg-[#5D5FEF0F]`}>
                            <label className={`generic-checkbox !block !font-normal`}>
                                <input
                                    type="checkbox"
                                    checked={!!selectedAssortment[item]}
                                    onChange={() => handleChange("checkAssortment", item)}
                                />
                                <span className="checkmark1"></span>
                                 <TextWithTooltip
                                    as='p'
                                    className='mb-0 text-[11px] font-normal'
                                    text={item}
                                    width={'100%'}
                                />
                            </label>
                        </div>
                    )) : !getTableComponentFifthListData?.isLoading ? <NoDataFound/> : null}
                    {getTableComponentFifthListData?.isLoading && <GenericSpinnerLoader />}
                    {(!showSelected && assortmentsList?.length > 0) && <div className='!border-0' style={{ width: "100%", height: "1px", backgroundColor: "red", visibility: "hidden", opacity: 0 }} ref={lastListElementRef}></div>}
                </div>
            </div>
        )
    };

    // Helper function to render cell content
    const renderCellContent = (key, row) => {
        if (key === "ontrack_status") {
            return (
                <div className="text-[11px]">
                    <div className={`font-medium ${
                        row.ontrack_status?.toLowerCase?.() === 'on-track' 
                            ? 'text-teal-600' 
                            : 'text-red-500'
                    }`}>
                        {row.ontrack_status || "N/A"}
                    </div>
                </div>
            );
        }
        
        if (key === "gsl_po") {
            return (
                <div className="flex items-center gap-2">
                    <span className="rightArrowLabel px-1.5 py-[1px] !text-xs !font-semibold !text-[#111D31] border border-transparent cursor-pointer hover:border-[#5d5fef] rounded-[3px]" onClick={() => handleChange("viewDocument", row)}>
                        {row?.gsl_po ?? "N/A"}
                    </span>
                </div>
            );
        }
        
        return <TextWithTooltip text={row?.[key] ?? "N/A"} width="100%" />;
    };

    // Virtual scrolling implementation
    const rowVirtualizer = useVirtualizer({
        count: tableData?.length || 0,
        getScrollElement: () => tableContainerRef.current,
        estimateSize: () => 32, // Estimated row height in pixels
        overscan: 20, // Render 20 extra rows above/below viewport for smooth scrolling
    });

    const renderTable = () => {
        if (getTableComponentFourthListData?.isLoading || getTableComponentListData?.isLoading) {
            return <TableLoader className="!px-0 mt-[10px] flex-1 overflow-auto" />
        }

        const virtualItems = rowVirtualizer.getVirtualItems();
        const totalColumns = Object.keys(headersData[headersType] ?? {}).length || 10;
        const totalHeight = rowVirtualizer.getTotalSize();
        const paddingTop = virtualItems.length > 0 ? virtualItems[0].start : 0;
        const paddingBottom = virtualItems.length > 0 
            ? totalHeight - (virtualItems[virtualItems.length - 1].end) 
            : 0;

        return (
            <div 
                ref={tableContainerRef}
                className="h-[calc(100%-64px)] mt-[8px] relative flex flex-col"
            >
                <div className="table-v2 bg-white rounded-[5px] shadow-sm border border-borderSlateGrey relative"
                //  style={{height:`${totalHeight + 36 + (tableData?.length === 0 ? 30 : 0) }px`}}
                 >
                    <table className="w-full" style={{ tableLayout: "fixed" }}>
                        <thead className="bg-[#F8F8F8] border-b border-gray-200 sticky top-0 !z-[1]">
                            <tr>
                                {Object.keys(headersData[headersType] ?? {})?.length > 0 &&
                                    Object.keys(headersData[headersType])?.map((key) => {
                                        const sortable = headersData?.columnType?.[key] !== "NOSORT";
                                        const isActive = sortConfig.sortedBy === key && !!sortConfig.sortedIn;
                                        return (
                                            <th
                                                key={key}
                                                className={`!border-r-0 group !py-[6px] !px-[2px] ${sortable ? "cursor-pointer select-none" : ""}`}
                                                onClick={sortable ? () => handleSort(key) : undefined}
                                            >
                                                  <span className="inline-flex items-center gap-1 rounded-[5px] w-full group-hover:bg-[#fff] px-[8px] py-[2px] border-transparent border group-hover:border-[#dae4ee]">
                                                        {headersData[headersType]?.[key]}
                                                        {sortable && (
                                                            isActive
                                                                ? (sortConfig.sortedIn === "ASC"
                                                                    ? <ArrowUp size={13} strokeWidth={2.2} className="shrink-0 text-[#5d5fef] invisible group-hover:visible" />
                                                                    : <ArrowDown size={13} strokeWidth={2.2} className="shrink-0 text-[#5d5fef] invisible group-hover:visible" />)
                                                                : <ArrowUp size={13} strokeWidth={1.6} className="shrink-0 text-[#94A3B8] invisible group-hover:visible" />
                                                        )}
                                                    </span>
                                            </th>
                                        );
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-borderSlateGrey">
                            {tableData?.length > 0 ? (
                                <>
                                    {paddingTop > 0 && (
                                        <tr key="virtual-spacer-top">
                                            <td style={{ height: `${paddingTop}px` }} colSpan={totalColumns} />
                                        </tr>
                                    )}
                                    {virtualItems.map((virtualRow) => {
                                        const row = tableData?.[virtualRow.index];
                                        // Tint the whole row by delivery status: on-track → green,
                                        // anything else with a status (delayed) → red. No status → neutral.
                                        const status = row?.ontrack_status?.toLowerCase?.();
                                        const rowTint = status === 'on-track'
                                            ? 'bg-emerald-50 hover:bg-emerald-100'
                                            : status
                                                ? 'bg-red-50 hover:bg-red-100'
                                                : 'hover:bg-gray-50';
                                        return (
                                            <tr 
                                                key={virtualRow.index}
                                                data-index={virtualRow.index}
                                                ref={rowVirtualizer.measureElement}
                                                className={`cursor-pointer h-[32px] ${rowTint}`}
                                            >
                                                {Object.keys(headersData[headersType] ?? {})?.map((key) => (
                                                    <td key={key} className="!border-r-0">
                                                        {renderCellContent(key, row)}
                                                    </td>
                                                ))}
                                            </tr>
                                        );
                                    })}
                                    {paddingBottom > 0 && (
                                        <tr key="virtual-spacer-bottom">
                                            <td style={{ height: `${paddingBottom}px` }} colSpan={totalColumns} />
                                        </tr>
                                    )}
                                </>
                            ) : (
                                <tr>
                                    <td 
                                        className="p-[8px] whitespace-nowrap text-[11px] text-gray-900 h-full" 
                                        colSpan={totalColumns}
                                    >
                                        <div className='h-full flex items-center justify-center'>
                                            No Data Found!
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    const handleFilterChange = (filterType) => {
        setFilters(prev => ({
            ...prev,
            [filterType]: !prev[filterType]
        }));
        setRefreshTable(true);
    };

    // Helper to get Icon based on name
    const getIcon = (name) => {
        const n = name?.toLowerCase() || "";
        const iconProps = { size: 16, className: "text-gray-500" };
        if (n.includes("fpt") || n.includes("gpt")) return <Icons.FPT {...iconProps} />;
        if (n.includes("pps")) return <Icons.PPS {...iconProps} />;
        if (n.includes("sewing")) return <Icons.Sewing {...iconProps} />;
        if (n.includes("cut")) return <Icons.Cutting {...iconProps} />;
        if (n.includes("pack")) return <Icons.Packaging {...iconProps} />;
        if (n.includes("dispatch") || n.includes("ship")) return <Truck {...iconProps} />;
        if (n.includes("sample")) return <Box {...iconProps} />;
        if (n.includes("qc") || n.includes("approval")) return <Clock {...iconProps} />; // Using Clock or clipboard if available
        if (n.includes("start")) return <Clock {...iconProps} />;
        if (n.includes("fabric")) return <Icons.FabricNew {...iconProps} />;
        if (n.includes("finish")) return <Icons.Finishing {...iconProps} />;
        return <Box {...iconProps} />;
    };

    const handleStatusNavigation = (direction) => {
        const data = tnaDashSummary?.tnaDashboardData || [];
        if (!data.length) return;

        const currentIndex = data.findIndex(item => item.status_name === statusName?.status_name);
        // If current status not found, default to first
        let indexToUse = currentIndex === -1 ? 0 : currentIndex;

        let newIndex;
        if (direction === 'next') {
            newIndex = indexToUse + 1;
            if (newIndex >= data.length) newIndex = 0; // Loop to start
        } else {
            newIndex = indexToUse - 1;
            if (newIndex < 0) newIndex = data.length - 1; // Loop to end
        }

        handleChange("statusName", data[newIndex]);
    };

    const renderCustomTable = () => {
        return (
            <div className='pr-[15px] pl-[30px] w-full h-full'>
                <div className="flex w-full h-[calc(100vh-192px)] gap-[15px]">

                    {renderAssortmentList()}

                    <div className="flex-1 flex flex-col w-[calc(100%-280px)] h-full">
                        <SplitPane direction="vertical" initialSplit={30} className="h-full">                            
                            {inputData?.viewMode?.key !== "tabularView" && <TNADashGraphView 
                                mainKey={"TNA_ANALYSIS"} 
                                graphData={tnaDashSummary?.tnaDashboardData} 
                                selectedStatus={statusName?.status_name}
                                onStatusChange={(data) => handleChange("statusName", data)}
                            />}
                            <div className='flex flex-col h-full'>
                                <div className="bg-white">
                                    <div className="flex items-center justify-between new-gen-pagination !m-0">
                                        <div className="flex items-center gap-4">
                                            <button 
                                                className="p-1 hover:bg-gray-100 rounded"
                                                onClick={() => handleStatusNavigation('prev')}
                                            >
                                                <ChevronLeft className="w-[20px] h-[20px] text-gray-600" />
                                            </button>

                                            {/* <div className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded">
                                                <Menu className="w-[16px] h-[16px] text-gray-600" />
                                                <span className="text-sm font-medium text-gray-900">Sewing</span>
                                                <ChevronDown className="w-[16px] h-[16px] text-gray-600" />
                                            </div> */}
                                            <GenericInput
                                                type="dropdown"
                                                value={statusName?.status_name ?? ""}
                                                onChange={(data) => handleChange("statusName", data)}
                                                inputProps={() => getInputProps("statusName")}
                                                genInputExtraClass="!m-0 !w-[150px]"
                                                iconLeft={<span className='mr-[5px]'>{getIcon(statusName?.status_name)}</span>}
                                                iconRight={<ChevronDown size={16} />}
                                            />

                                            <button 
                                                className="p-1 hover:bg-gray-100 rounded"
                                                onClick={() => handleStatusNavigation('next')}
                                            >
                                                <ChevronRight className="w-[20px] h-[20px] text-gray-600" />
                                            </button>
                                        </div>

                                        <div className="flex items-center gap-3">
                                            <GenericInput
                                                type="text"
                                                placeholder="Search"
                                                value={searchQuery}
                                                dependentFieldsObject={[searchQuery]}
                                                onChange={(e) => handleChange("searchTableData", e)}
                                                onKeyDown={(e) => e.key == 'Enter' ? setRefreshTable(true) : false}
                                                iconLeft={<Search className="w-[16px] h-[16px] text-gray-400 mr-[5px]" />}
                                                genInputExtraClass="!m-0 !w-[150px]"
                                            />

                                            <span className='flex w-[1px] h-[16px] bg-[#dae4ee]'></span>

                                            <div className="ngp-right tablePagination">
                                                <div className="nt-btn">
                                                    <div className="pagination-inner">
                                                        <ul className="pagination-item">
                                                            <li className='!flex !items-center'>
                                                                <button className={`${tnaTableData?.currentPage == 1 && "gen-action-btn-disable disable-"}first-btn !h-[32px] !border !border-solid !border-[#dae4ee] !rounded-[3px]`} disabled={tnaTableData?.currentPage == 1} onClick={() => changePage(1)}>
                                                                    <span className="page-item-btn-inner">
                                                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M10.8977 6.49114C11.2557 6.84912 11.2557 7.42952 10.8977 7.7875L6.96254 11.7227L10.8977 15.6578C11.2557 16.0158 11.2557 16.5962 10.8977 16.9542C10.5397 17.3122 9.95931 17.3122 9.60133 16.9542L5.018 12.3708C4.66002 12.0129 4.66002 11.4325 5.018 11.0745L9.60133 6.49114C9.95931 6.13316 10.5397 6.13316 10.8977 6.49114Z" fill="#23235F" />
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M17.3143 6.49114C17.6723 6.84912 17.6723 7.42952 17.3143 7.7875L13.3792 11.7227L17.3143 15.6578C17.6723 16.0158 17.6723 16.5962 17.3143 16.9542C16.9563 17.3122 16.3759 17.3122 16.018 16.9542L11.4346 12.3708C11.0766 12.0129 11.0766 11.4325 11.4346 11.0745L16.018 6.49114C16.3759 6.13316 16.9563 6.13316 17.3143 6.49114Z" fill="#23235F" />
                                                                        </svg>
                                                                    </span>
                                                                </button>
                                                            </li>
                                                            <li className='!flex !items-center'>
                                                                <button className={`${tnaTableData?.currentPage == 1 && "gen-action-btn-disable dis-"}prev-btn !h-[32px] !border !border-solid !border-[#dae4ee] !rounded-[3px] !justify-center`} disabled={tnaTableData?.currentPage == 1} onClick={() => changePage(tnaTableData?.currentPage - 1)}>
                                                                    <span className="page-item-btn-inner">
                                                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M6.89781 0.491142C7.2558 0.849122 7.2558 1.42952 6.89781 1.7875L2.96266 5.72266L6.89781 9.65781C7.2558 10.0158 7.2558 10.5962 6.89781 10.9542C6.53983 11.3122 5.95943 11.3122 5.60145 10.9542L1.01812 6.37084C0.660139 6.01286 0.660139 5.43246 1.01812 5.07448L5.60145 0.491142C5.95943 0.133161 6.53983 0.133161 6.89781 0.491142Z" fill="#23235F" />
                                                                        </svg>
                                                                    </span>
                                                                </button>
                                                            </li>
                                                            <li className='!flex !items-center'>
                                                                {!enableJumpPage ? <button className="pi-number-btn !h-[32px] !border !border-solid !border-[#dae4ee] !rounded-[3px]" onClick={() => handleJumpPage()}>
                                                                    <span>{tnaTableData?.currentPage}<label className='m-0'>of</label>{tnaTableData?.maxPage}</span>
                                                                </button> : <input
                                                                    ref={jumpInputRef}
                                                                    className="inline-block w-[60px] h-[28px] border border-[#dae4ee] px-[3px] pl-[5px] rounded-[4px] shadow-[0px_0px_0px_2px_#DADAFF] font-medium text-xs"
                                                                    onChange={setPageNumberValue}
                                                                    onKeyDown={setPageNumberValue}
                                                                    type="number"
                                                                    autoComplete="off"
                                                                    value={tnaTableData?.pageNumber}
                                                                />}
                                                            </li>

                                                            <li className='!flex !items-center'>
                                                                <button className={`${tnaTableData?.currentPage == tnaTableData?.maxPage && "gen-action-btn-disable dis-"}next-btn !h-[32px] !border !border-solid !border-[#dae4ee] !rounded-[3px] !justify-center`} disabled={tnaTableData?.currentPage == tnaTableData?.maxPage} onClick={() => changePage(tnaTableData?.currentPage + 1)}>
                                                                    <span className="page-item-btn-inner">
                                                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fillRule="evenodd" clipRule="evenodd" d="M0.934461 0.491142C0.57648 0.849122 0.57648 1.42952 0.934461 1.7875L4.86961 5.72266L0.934461 9.65781C0.57648 10.0158 0.57648 10.5962 0.934461 10.9542C1.29244 11.3122 1.87284 11.3122 2.23082 10.9542L6.81416 6.37084C7.17214 6.01286 7.17214 5.43246 6.81416 5.07448L2.23082 0.491142C1.87284 0.133161 1.29244 0.133161 0.934461 0.491142Z" fill="#23235F" />
                                                                        </svg>
                                                                    </span>
                                                                </button>
                                                            </li>
                                                            <li className='!flex !items-center'>
                                                                <button className={`${tnaTableData?.currentPage == tnaTableData?.maxPage && "gen-action-btn-disable dis-"}last-btn !h-[32px] !border !border-solid !border-[#dae4ee] !rounded-[3px]`} disabled={tnaTableData?.currentPage == tnaTableData?.maxPage} onClick={() => changePage(tnaTableData?.maxPage)}>
                                                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.9346 6.49114C11.5766 6.84912 11.5766 7.42952 11.9346 7.7875L15.8697 11.7227L11.9346 15.6578C11.5766 16.0158 11.5766 16.5962 11.9346 16.9542C12.2926 17.3122 12.873 17.3122 13.2309 16.9542L17.8143 12.3708C18.1723 12.0129 18.1723 11.4325 17.8143 11.0745L13.2309 6.49114C12.873 6.13316 12.2926 6.13316 11.9346 6.49114Z" fill="#23235F" />
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.51796 6.49114C5.15998 6.84912 5.15998 7.42952 5.51796 7.7875L9.45311 11.7227L5.51796 15.6578C5.15998 16.0158 5.15998 16.5962 5.51796 16.9542C5.87594 17.3122 6.45634 17.3122 6.81432 16.9542L11.3977 12.3708C11.7556 12.0129 11.7556 11.4325 11.3977 11.0745L6.81432 6.49114C6.45634 6.13316 5.87594 6.13316 5.51796 6.49114Z" fill="#23235F" />
                                                                    </svg>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <span className='flex w-[1px] h-[16px] bg-[#dae4ee]'></span>

                                            <div className="flex items-center gap-4 border border-solid border-[#dae4ee] rounded-[3px] h-[32px] px-[8px]">
                                                <div className="flex items-center gap-2">
                                                    <label className={`generic-checkbox !block !font-normal`}>
                                                        <input
                                                            type="checkbox"
                                                            checked={filters.onTrack}
                                                            onChange={() => handleFilterChange('onTrack')}
                                                        />
                                                        <span className="checkmark1 !top-0"></span>
                                                        <span className="text-xs font-semibold text-[#0d9488]">On Track</span>
                                                        <span className="text-xs font-semibold text-fontBlack ml-[10px]">{statusName?.on_track_count ?? 0}</span>
                                                    </label>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <label className={`generic-checkbox !block !font-normal`}>
                                                        <input
                                                            type="checkbox"
                                                            checked={filters.delayed}
                                                            onChange={() => handleFilterChange('delayed')}
                                                        />
                                                        <span className="checkmark1 !top-0"></span>
                                                        <span className="text-xs font-semibold text-[#FD3757]">Delayed</span>
                                                        <span className="text-xs font-semibold text-fontBlack ml-[10px]">{statusName?.delayed_count ?? 0}</span>
                                                    </label>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {renderTable()}
                                {/* <SplitPane direction="vertical" initialSplit={60} className="flex-1 rounded-xl overflow-hidden border border-white/10">
                                    <Panel label="preview" color="#111118">
                                    
                                    </Panel>
                                </SplitPane> */}
                            </div>
                        </SplitPane>
                    </div>
                </div>
            </div>
        )
    }

    const inputFields = [
        { type: "dropdown", placeholder: "Vendor", value: "", key: "vendor", iconRight: <Icons.DownArrowNew />, genInputExtraClass: "!max-w-[140px]" },
        { type: "dropdown", placeholder: "Site", value: "", key: "site", iconRight: <Icons.DownArrowNew />, genInputExtraClass: "!max-w-[140px]" },
        { type: "range", placeholder: ["Date From", "Date To"], value: "", key: "dateRange", genInputExtraClass: "!w-[250px]" },
    ];

    const getInputProps = (key) => {

        const commonProps = {
            modalMainClass: 'mt-[4px] !top-full'
        }

        switch (key) {
            case "site": {
                return ({
                    ...commonProps,
                    search: {
                        placeholder: `Search Site`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": "site",
                                "key": "name1",
                                "code": "code",
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        return response?.resource?.searchResultNew?.map(data => ({ ["site"]: data["name1"], ...data }))
                    },
                    headerKeys: {
                        site: { value: ["site"] },
                    },
                    itemKeys: {
                        site: ["site"],
                    }
                })
            }
            case "vendor": {
                return ({
                    ...commonProps,
                    search: {
                        placeholder: "Search Vendor",
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": "vendor",
                                "key": "slname",
                                "code": "slcode",
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        return response?.resource?.searchResultNew?.map(data => ({ ["vendor"]: data["slname"], ...data }))
                    },
                    headerKeys: {
                        vendor: { value: "Name" },
                        slcode: { value: "Code" },
                    },
                    itemKeys: {
                        vendor: ["vendor"],
                        slcode: ["slcode"],
                    }
                })
            }
            case "assortment": {
                return ({
                    ...commonProps,
                    search: {
                        placeholder: `Search Site`,
                    },
                    viewDataType: "table-view",
                    api: {
                        reduxState: 'generalStore',
                        apiName: 'getSearchFilters',
                        apiPayload: (params) => {
                            return {
                                "entity": "generic_final_assortment",
                                "key": "assortment_name",
                                "code": "",
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "moduleName": "",
                                "other_data": {},
                                "columnName": {}
                            }
                        },
                        getMaxPage: (states, functions, response) => Number(response?.resource?.maxPage || ""),
                    },
                    getListData: (response) => {
                        return response?.resource?.searchResultNew?.map(data => ({ ["assortment"]: data["assortment_name"], ...data }))
                    },
                    headerKeys: {
                        assortment: { value: ["assortment"] },
                    },
                    itemKeys: {
                        assortment: ["assortment"],
                    }
                })
            }
            case "viewMode": {
                return ({
                    ...commonProps,
                    getListData: (response) => {
                        return [
                            {
                                icon: <ChartLine size={19} strokeWidth={1.75} />,
                                key: "graphicalView",
                                viewMode: "Graphical View",
                            },
                            {
                                icon: <Table2 size={19} strokeWidth={1.75} />,
                                key: "tabularView",
                                viewMode: "Tabular View",
                            }
                        ];
                    },
                    headerKeys: {
                        "viewMode": { value: "View Type" },
                    },
                    itemKeys: {
                        viewMode: [(state, functions, data) => {
                            return (<span className="flex items-center">{data?.icon} <span className="font-medium !text-[12px] ml-[5px]">{data?.viewMode}</span></span>)
                        }]
                    },
                })
            }
            case "dateRange": {
                return ({
                    hideDefaultRanges: true, format: "DD-MM-YYYY"
                })
            }
            case "statusName": {
                const mappedData = tnaDashSummary?.tnaDashboardData?.map((item) => ({
                    ...item,
                    statusName: item?.status_name
                })) || [];

                const allItem = {
                    on_track_count: mappedData.reduce((sum, item) => sum + (item.on_track_count || 0), 0),
                    delayed_count: mappedData.reduce((sum, item) => sum + (item.delayed_count || 0), 0),
                    total_count: mappedData.reduce((sum, item) => sum + (item.total_count || 0), 0),
                    status_name: "All",
                    statusName: "All",
                    status_order: -1
                };
                return {
                    modalMainClass: "!top-[35px] !z-[3]",
                    getListData: () => [allItem, ...mappedData],
                    headerKeys: {
                        [key]: {
                            value: "Name",
                        }
                    },
                    itemKeys: {
                        [key]: [key]
                    },
                }
            }

            default:
                break;
        }
    };

    const handleChange = (type, data) => {
        switch (type) {
            case "designStage":
                setSelectedModal(type);
                setSelectedData(data);
                break;
            case "statusName": {
                setStatusName(data);
                setRefreshTable(true)
                break;
            }
            case "checkAssortment": {
                setSelectedAssortment(prev => {
                    const updated = { ...prev };
                    if (updated[data]) {
                        delete updated[data];
                    } else {
                        updated[data] = true;
                    }
                    return updated;
                });
                setUpdatetablePayload(true)
                break;
            }
            case "search": {
                setAssortmentsList([])
                setCurrentPage(1);
                getAssortmentListData();
                break;
            }
            case "searchTableData": {
                setSearchQuery(data?.target?.value ?? "");
                if(!(data?.target?.value ?? "")) {
                    setRefreshTable(true)
                }
                break;
            }
             case "viewDocument": {
                let obj = modifyDataForDocumentViewerUrlInsertion("encode", {
                    documentId: data?.gsl_po,
                    documentNo: data?.gsl_po,
                    documentType: "PO",
                    poType: data?.poType,
                });

                // Update the url search params here.
                setPayloadAsURLParams({
                    data: {
                        ...getPayloadFromURLParams({
                            l: location,
                        }),
                        documentViewerConfig: obj,
                    },
                    l: location,
                    h: history,
                });
                break;
            }
            default: {
                let updateInputData = { ...inputData };
                updateInputData[type] = data
                setInputData(updateInputData);
                if(type !== "viewMode"){
                    setUpdatetablePayload(true)
                }
            }
                break;
        }
    }

    const renderTopExtras = () => {
        return (
            <div className='w-full pr-[15px] pl-[30px] py-[20px] bg-[#f3f4fa] relative z-[2]'>
                <div className="px-4 py-3 bg-white rounded-[5px] flex items-center justify-between gap-8">
                    <div className='flex items-center gap-2 relative z-50'>
                        {/* <h1 className="mb-0 text-[14px] font-bold text-black mr-[10px]">TNA Assortment</h1> */}
                        {/* <p className='text-[11px] text-[#67768E] m-0'>Combination from Item Master as defined in Global Config.</p> */}
                        {inputFields?.map((item, index) =>
                            <GenericInput
                                key={index}
                                genInputExtraClass={`!mb-0 whitespace-nowrap ${item?.genInputExtraClass}`}
                                type={item?.type}
                                placeholder={item?.placeholder}
                                value={item?.key === "dateRange" ? inputData?.[item?.key] : inputData?.[item?.key]?.[item?.key] || ""}
                                iconLeft={item?.iconLeft}
                                iconRight={item?.iconRight}
                                inputProps={() => getInputProps(item?.key)}
                                onChange={(data) => handleChange(item?.key, data)}
                                dependentFieldsObject={[inputData?.[item?.key]?.[item?.key]]}
                            />
                        )}
                        <GenericCustomButton
                            type='default'
                            label={'Clear All'}
                            disabled={inputData["vendor"] || inputData["site"] || inputData["dateRange"] ? false : true}
                            onClick={()=> {
                                setInputData({
                                viewMode: {
                                    icon: <ChartLine size={19} strokeWidth={1.75} />,
                                    key: "graphicalView",
                                    viewMode: "Graphical View",
                                }
                            })
                            setUpdatetablePayload(true)
                        }}
                        />
                    </div>

                    <div className="flex items-center gap-2 relative z-50">
                        {[{ type: "dropdown", placeholder: "Graphical View", value: "", key: "viewMode", iconRight: <Icons.DownArrowNew />, iconLeft: <span className='mr-1'>{inputData?.viewMode?.icon ?? <ChartLine size={19} strokeWidth={1.75} />}</span>, genInputExtraClass: '!max-w-[140px] min-w-[160px] max-w-none' }]?.map((item, index) =>
                            <GenericInput
                                key={index}
                                genInputExtraClass={`!mb-0 whitespace-nowrap ${item?.genInputExtraClass}`}
                                type={item?.type}
                                placeholder={item?.placeholder}
                                value={inputData?.[item?.key]?.[item?.key] || ""}
                                iconLeft={item?.iconLeft}
                                iconRight={item?.iconRight}
                                inputProps={() => getInputProps(item?.key)}
                                onChange={(data) => handleChange(item?.key, data)}
                                // dependentFieldsObject={[inputData?.[item?.key]?.[item?.key]]}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const getTnaSummaryData = () => {
        let payload = {
            displayName: "TNA_DASHBOARD_DATA",
            filter: {
                tna_assortment_name: Object.keys(selectedAssortment).length > 0 ? Object.keys(selectedAssortment)?.join(",") : undefined,
                slcode: inputData?.vendor?.slcode ?? undefined,
                site_code: inputData?.site?.code ?? undefined,
                po_date: inputData?.dateRange?.[0] ? {
                    from: dayjs(inputData?.dateRange?.[0]?.$d).format("YYYY-MM-DD"),
                    to: dayjs(inputData?.dateRange?.[1]?.$d).format("YYYY-MM-DD")
                } : undefined
            },
            apiUrl: "/purchase/dashboard/tna/analysis",
            baseUrl: CONFIG.SM_BACKEND_BASE_URL,
        };
        dispatchHandler(dispatch, "getTableComponentFourthListRequest", payload, getPermissionKey("dashboard", "tna", "view"))
    }

    const handleSort = (key) => {
        if (headersData?.columnType?.[key] === "NOSORT") return;
        setSortConfig(prev => ({
            sortedBy: key,
            sortedIn: prev.sortedBy === key && prev.sortedIn === "ASC" ? "DESC" : "ASC"
        }));
        setRefreshTable(true);
    };

    const getTableData = (data) => {
        let payload = {
            displayName: "TNA_DASHBOARD_DATA",
            filter: {
                tna_assortment_name: Object.keys(selectedAssortment).length > 0 ? Object.keys(selectedAssortment)?.join(",") : undefined,
                slcode: inputData?.vendor?.slcode ?? undefined,
                site_code: inputData?.site?.code ?? undefined,
                po_date: inputData?.dateRange?.[0] ? {
                    from: dayjs(inputData?.dateRange?.[0]?.$d).format("YYYY-MM-DD"),
                    to: dayjs(inputData?.dateRange?.[1]?.$d).format("YYYY-MM-DD")
                } : undefined,
                ontrack_status: (filters.onTrack && filters.delayed) ? undefined : filters.onTrack ? "on-track" : filters?.delayed ? "delayed" : undefined
            },
            apiUrl: "/purchase/dashboard/tna/analysis",
            baseUrl: CONFIG.SM_BACKEND_BASE_URL,
            analysisType: "tabular", 
            statusName: statusName?.status_name ?? "",
            pageNo: data?.pageNo ?? 1,
            pageSize: 15,
            search: searchQuery ?? "",
            sortedBy: sortConfig.sortedBy || "",
            sortedIn: sortConfig.sortedIn || ""
        };
        dispatchHandler(dispatch, "getTableComponentListRequest", payload, getPermissionKey("dashboard", "tna", "view"))
        
    }

    useEffect(() => {
        if (updatetablePayload) {
            setUpdatetablePayload(false);
            getTnaSummaryData();
        }
    }, [updatetablePayload]);

    const getParentChildProps = () => {
        let payload = {
            closeModal: () => { setSelectedModal(false); setSelectedData("") },
            animationType: "bottom",
            parentModalOuterMostClassName: 'flex items-center justify-center',
        }
        switch (selectedModal) {
            case "designStage": return {
                ...payload,
                postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", margin: 0 },
                dimensions: { width: "700px", height: "100vh", maxWidth: '100vw', borderRadius: 5 },
                animationType: "right",
                selectedData
            }

            default:
                break;
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "designStage": return DesignStagesModal;
            default: return <React.Fragment></React.Fragment>
        }
    }

    useEffect(() => {
        if (refreshTable) {
            getTableData();
            setRefreshTable(false);
        }
    }, [refreshTable])

    return (
        <div className='w-full tna-analysis-dashboard'>
            {renderTopExtras()}
            {renderCustomTable()}
            {selectedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false); setSelectedData("") }}
            />}
        </div>
    )
}

export default TNAAnalysis;